import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { gotologin } from '../actions/UserActions';

interface PasswordResetSuccessProps {
    gotologin?();
}

class PasswordResetSuccess extends React.Component<RouteComponentProps<{}> & PasswordResetSuccessProps, {}> {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);        
    }
    handleSubmit() {
        this.props.gotologin();
    }

    public render() {
        return <div className="wrapper">
            <div className="form-signin">
                <h2 className="form-signin-heading">Success!</h2>
                <div className="messageBox">
                    <h3>Your account password has been successfully changed.</h3>
                    <p>Please login to IRIS Portal with your new password.</p>
                    <button className="btn btn-1 btn-1e continue" type="button" onClick={this.handleSubmit}>Continue to login
                                        <i className="fa fa-sign-in"></i>
                        </button>
                </div>
            </div>
        </div>;
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            gotologin: gotologin
        }, dispatch
    )
}
export default connect(
   null,
    matchDispatchToProps
)(PasswordResetSuccess);